import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';
import Action from './pages/Action';
import ActionArticle from './pages/ActionArticle';
import Resources from './pages/Resources';
import AddResource from './pages/AddResource';
import ResourceDetail from './pages/ResourceDetail';
import About from './pages/About';
import Layout from './components/Layout';
import Map from './components/Map';
import IncidentInfo from './pages/IncidentInfo';
import './App.css';
import { IncidentProvider } from './context/IncidentContext';
import StartupPage from './pages/StartupPage';
import StoryArchive from './pages/StoryArchive';
import MemoryThreads from './pages/MemoryThreads';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
// 模拟数据只允许在 npm start 的开发预览中使用，生产构建不会启用。
const previewMode = process.env.NODE_ENV === 'development' && process.env.REACT_APP_PREVIEW_DATA === 'true';
let supabase = null;
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_PREVIEW_DATA === 'true') {
  supabase = require('./preview/mockClient').createMockClient();
} else if (supabaseUrl && supabaseKey) {
  supabase = createClient(supabaseUrl, supabaseKey);
}

function App() {
  return (
    <IncidentProvider>
      <Router>
        {previewMode && <div role="status" style={{ position: 'fixed', bottom: 8, right: 8, zIndex: 2000, padding: '4px 9px', borderRadius: 4, background: '#fff3cd', color: '#513d00', font: '12px/1.5 sans-serif', pointerEvents: 'none' }}>本地模拟预览 · 非真实数据 · 提交刷新后重置</div>}
        <Layout>
          <Routes>
            <Route path="/" element={<StartupPage supabase={supabase} />} />
            <Route path="/map" element={<Map supabase={supabase} />} />
            <Route path="/incident" element={<IncidentInfo supabase={supabase} />} />
            <Route path="/archive" element={<StoryArchive supabase={supabase} />} />
            <Route path="/threads" element={<MemoryThreads supabase={supabase} />} />
            <Route path="/action" element={<Action />} />
            <Route path="/action/:id" element={<ActionArticle />} />
            <Route path="/resources" element={<Resources supabase={supabase} />} />
            <Route path="/resources/add" element={<AddResource supabase={supabase} />} />
            <Route path="/resource-detail" element={<ResourceDetail supabase={supabase} />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Layout>
      </Router>
    </IncidentProvider>
  );
}

export default App;
